var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$vuetify.breakpoint.smAndDown
        ? _c("landing-page-mobile")
        : _c("landing-page-desktop"),
      _vm._v(" "),
      _c("welcome-message")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }